/**
 * Formie 4 scrolls with scrollIntoView, which ignores the fixed header and nav.
 * Redirect those calls for Formie elements so the target clears the header.
 */

function getFixedTopOffset() {
  let bottom = 0;

  document
    .querySelectorAll('.site-header, .site-menu, .site-menu__bg')
    .forEach((el) => {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (style.position !== 'fixed' && style.position !== 'sticky') return;

      bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
    });

  return bottom;
}

function scrollToWithOffset(target, behavior = 'smooth') {
  const main = document.querySelector('#main');

  const doScroll = () => {
    const offset = getFixedTopOffset();
    const y = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: Math.max(0, y), behavior });
  };

  if (!main) {
    doScroll();
    return;
  }

  main.classList.add('is-programmatic-scroll');
  if (!main.classList.contains('is-menu-open')) {
    main.classList.remove('is-menu-compacted');
  }

  // Let layout settle after expanding the header before measuring.
  requestAnimationFrame(() => {
    requestAnimationFrame(doScroll);
  });

  const finishProgrammaticScroll = () => {
    if (!main.classList.contains('is-programmatic-scroll')) return;
    main.classList.remove('is-programmatic-scroll');
    window.dispatchEvent(new CustomEvent('scroll'));
  };

  if (behavior === 'instant' || behavior === 'auto') {
    finishProgrammaticScroll();
    return;
  }

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    window.removeEventListener('scrollend', finish);
    clearTimeout(fallbackTimer);
    finishProgrammaticScroll();
  };

  window.addEventListener('scrollend', finish, { once: true });
  const fallbackTimer = setTimeout(finish, 1000);
}

const nativeScrollIntoView = Element.prototype.scrollIntoView;

Element.prototype.scrollIntoView = function scrollIntoViewWithHeaderOffset(
  options
) {
  const inForm = this.closest?.('[data-formie-form], [data-formie]');

  if (!inForm) {
    return nativeScrollIntoView.call(this, options);
  }

  const behavior =
    options && typeof options === 'object' && options.behavior
      ? options.behavior
      : 'auto';

  scrollToWithOffset(this, behavior === 'smooth' ? 'smooth' : 'instant');
};

function scrollFormIntoView(form) {
  if (!(form instanceof Element)) return;

  const message = form.querySelector(
    '[data-formie-message-error], [data-formie-message-success], [data-formie-message]'
  );
  const target =
    message && message.getBoundingClientRect().height > 0 ? message : form;

  scrollToWithOffset(target);
}

document.addEventListener('formie:page:navigate:after', (event) => {
  const form =
    event.target instanceof HTMLFormElement
      ? event.target
      : event.target?.closest?.('form');

  if (!(form instanceof HTMLFormElement)) return;
  if (form.getAttribute('data-formie-scroll-to-top') === 'false') return;

  scrollFormIntoView(form);
});
